import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function ThankYouEvents() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100"
        >
          <div className="mb-6 flex justify-center">
            <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center">
              <svg className="w-10 h-10 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
          
          <h1 className="text-3xl font-display font-bold text-gray-900 mb-4">
            Thank You for Your Event Enquiry!
          </h1>
          
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            Your enquiry has been successfully submitted. Our team will be in touch with you shortly to discuss your event needs.
          </p>
          
          <div className="space-y-4">
            <Link 
              to="/" 
              className="btn-primary w-full inline-block text-center py-3"
            >
              Back to Home
            </Link>
          </div>
        </motion.div>
        
        <p className="mt-8 text-sm text-gray-500">
          Need immediate assistance? <Link to="/contact" className="text-primary-600 font-medium hover:text-primary-700">Contact us directly</Link>
        </p>
      </div>
    </div>
  );
}

export default ThankYouEvents;
